import {AfterViewChecked, Component, HostListener, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {CustomStyleService} from '../../services/custom-style.service';
import {AccountPermissionsService} from '../../services/account-permissions.service';
import {ApiClientService} from '../../services/api-client.service';
import {Router} from '@angular/router';
import { ResidentService } from '../../services/resident.service';
import { ServiceRequestService } from '../../services/service-request.service';
import { ParcelsService } from '../../services/parcels.service';
import { UrlService } from '../../services/url.service';
import { EmailService } from '../../services/email.service';
import { AmenitiesService } from '../../services/amenities.service';
import { ResidentServicesService } from '../../services/resident-services.service';
import { DocumentsService } from '../../services/documents.service';
import {ProfileService} from '../../views/profile/services/profile.service';
import { FrontDeskInstructionsService } from 'app/services/front-desk-instructions.service';
import { CondomanagerService } from '../../services/condomanager.service';
import {environment} from '../../../environments/environment';
import {ParkingPassService} from '../../services/parking-pass.service';
import {StripeAccountsService} from '../../services/stripe-accounts.service';
import { BuildingApiService } from '../../services/api/building-api.service';

declare const $: any;
declare const window: any;
declare const toastr: any;

@Component({
    selector: 'navigation',
    templateUrl: 'navigation.component.html',
    styleUrls: ['navigation.component.scss']
})

export class NavigationComponent implements AfterViewChecked, OnInit {
    initialListData: Array<any> = [];
    allowedListData: Array<any> = [];
    isProfileActionsShow: boolean = false;
    isMaxTvLinkAvailable: boolean = false;
    isLinkLoading: boolean = false;
    showSettingsSideMenu: boolean = false;
    linkPriorToSettings: string = '';
    isIn = false;
    selected: any;
    buildings: any;
    noticePmiUrl = '';

    constructor(public authenticationService: AuthenticationService,
                public cs: CustomStyleService,
                public accountService: AccountPermissionsService,
                public api: ApiClientService,
                public router: Router,
                public residentService: ResidentService,
                private serviceRequestService: ServiceRequestService,
                private parcelsService: ParcelsService,
                public urlService: UrlService,
                private emailService: EmailService,
                private amenitiesService: AmenitiesService,
                private residentServicesService: ResidentServicesService,
                private documentsService: DocumentsService,
                private profileService: ProfileService,
                private frontDeskInstructionsService: FrontDeskInstructionsService,
                public condomanagerService: CondomanagerService,
                public parkingPassService: ParkingPassService,
                public stripeAccountsService: StripeAccountsService,
                private buildingApi: BuildingApiService
    ) {
        this.accountService.onPermissionsUpdate.subscribe(() => {
            this.setNavigationData();
        });

        this.accountService.init();
    }

    ngOnInit() {
        this.urlService.routeChanged.subscribe(() => this.setActiveGroup());

        if (this.authenticationService.userIsResident) {
            this.residentService.getBuildingsInfo()
                .then(() => {
                    this.buildings = JSON.parse(localStorage.getItem('residentBuildings'));
                    this.selected = JSON.parse(localStorage.getItem('residentselectedBuilding'));
                })
                .then(() => {
                    const cNSettings = this.residentService.selectedBuilding.cNSettings;
                    if(Object.keys(this.residentService.selectedBuilding).length > 1) {
                        this.condomanagerService.checkEntries();
                        this.checkAndSetPublicUrlNotices();

                        this.residentServicesService.itemsOfServices = [];

                        if (this.residentService.selectedBuilding.rolePermissions) {
                            this.residentService.selectedBuilding.rolePermissions.forEach(
                                key => this.residentServicesService.itemsOfServices.push(this.residentServicesService.dictionary[key])
                            );
                        }

                        if (this.residentService.selectedBuilding.rolePermissions.indexOf('parking_pass') != -1) {
                            this.residentService.getResidentLots(this.selected.buildingId);
                        }

                        if (this.residentService.selectedBuilding.rolePermissions.indexOf('amenity') != -1) {
                            this.amenitiesService.getAmenitiesListByBuilding(this.selected.buildingId);
                        }

                        if (cNSettings && cNSettings.useResidentInstruction) {
                            this.residentServicesService.itemsOfServices.push(this.residentServicesService.dictionary['front_desk_instructions']);
                        }
                    } else
                        this.residentServicesService.itemsOfServices = [];
                });
        } else {
            this.residentService.selectedBuilding = {};
            this.residentService.buildings = [];
            this.hasStripeAccount();
        }

        const sideMenuPathTriggers = [
            'directory_settings',
            'amenities_settings',
            'parking_passes_settings',
            'website_builder',
            'parcels_settings',
            'service-request-settings',
            'integrations_settings',
            'key_log_settings',
            'incident_report_settings',
            'pass_on_log_settings',
            'email_merge_settings',
            'settings-sms'
            // 'stripe-accounts'
        ];

        if (sideMenuPathTriggers.includes(this.router.url.substr(1).split('?')[0])) {
            setTimeout(() => this.showSettingsSideMenu = true, 300);
        }
    }

    ngAfterViewChecked() {
        const $body = $('body');
        if ($(window).width() < 769) $body.addClass('body-small');
        else $body.removeClass('body-small');
    }

    toggleState() {
        this.isIn = !this.isIn;
    }

    setNavigationData() {
        this.initialListData = [
            {
                groupTitle: 'Communication',
                icon: 'paper-plane.svg',
                isAllowed: true,
                isGroupActive: false,
                links: [
                    {
                        title: 'Email Merge',
                        route: '/email-merge',
                        isAllowed: this.accountService.isServiceAllowed('email_merge')
                    },
                    {
                        title: 'Service Request',
                        route: '/service-request',
                        isAllowed: this.accountService.isServiceAllowed('service_request')
                    },
                    {
                        title: 'Announcements',
                        route: '/announcements',
                        isAllowed: this.accountService.isServiceAllowed('announcements')
                    },
                    {
                        title: 'Community',
                        route: '/community',
                        isAllowed: false
                    }
                ]
            },
            {
                groupTitle: 'Record Keeping',
                icon: 'user.svg',
                isAllowed: true,
                isGroupActive: false,
                links: [
                    {
                        title: 'Directory',
                        route: '/directory',
                        isAllowed: this.accountService.isServiceAllowed('bldn')
                    },
                    {
                        title: 'Parcels',
                        route: '/parcels',
                        isAllowed: this.accountService.isServiceAllowed('parcels')
                    },
                    {
                        title: 'Key Log',
                        route: '/key-log',
                        isAllowed: this.accountService.isServiceAllowed('key_log')
                    },
                    {
                        title: 'Documents',
                        route: '/documents',
                        isAllowed: this.accountService.isServiceAllowed('documents')
                    },
                    {
                        title: 'Amenities',
                        route: '/amenities',
                        isAllowed: this.accountService.isServiceAllowed('amenity')
                    },
                    {
                        title: 'Parking Pass',
                        route: '/parking_passes',
                        isAllowed: this.accountService.isServiceAllowed('parking_pass')
                    },
                    {
                        title: 'Report Generator',
                        route: '/report-generator',
                        isAllowed: this.accountService.isServiceAllowed('report_builder')
                    },
                    {
                        title: 'Maintenance Calendar',
                        route: '/maintenance-calendar',
                        isAllowed: this.authenticationService.user.userType == 'super_admin'
                    },
                    {
                        title: 'Classifieds',
                        route: '/classifieds-mcc',
                        isAllowed: this.authenticationService.user.userType == 'super_admin' // this.accountService.canSetup('service_request')
                    }
                ]
            },
            {
                groupTitle: 'Security',
                icon: 'shield-alt.svg',
                isAllowed: true,
                isGroupActive: false,
                links: [
                    {
                        title: 'Pass On Log',
                        route: '/pass-on-log',
                        isAllowed: this.accountService.isServiceAllowed('pass_on_log')
                    },
                    {
                        title: 'Daily Reports',
                        route: '/daily-reports',
                        isAllowed: this.accountService.isServiceAllowed('daily_report')
                    },
                    {
                        title: 'Incident Reports',
                        route: '/incident-reports',
                        isAllowed: this.accountService.isServiceAllowed('inc_report')
                    }
                ]
            },
            {
                groupTitle: 'Administration',
                icon: 'lock.svg',
                isAllowed: this.accountService.isServiceAllowed('auth'),
                isGroupActive: false,
                links: [
                    {
                        title: 'Management Company',
                        route: '/management-company',
                        isAllowed: this.accountService.isUserAdmin()
                    },
                    {
                        title: 'Properties',
                        route: '/property',
                        isAllowed: true
                    },
                    {
                        title: 'Users',
                        route: '/user',
                        isAllowed: true
                    },
                    {
                        title: 'Themes',
                        route: '/themes',
                        isAllowed: this.accountService.isUserAdmin()
                    },
                    {
                        title: 'User Roles',
                        route: '/user-role',
                        isAllowed: true
                    },
                    {
                        title: 'Stripe',
                        route: '/stripe-accounts',
                        isAllowed: false
                    }
                ]
            },
            {
                groupTitle: 'Statistics',
                icon: '',
                // isAllowed: this.accountService.isServiceAllowed('auth'),
                isAllowed: this.accountService.isUserAdmin(),
                isGroupActive: false,
                links: [
                    {
                        title: 'Users',
                        route: '/user-statistics',
                        isAllowed: this.accountService.isUserAdmin()
                    }
                ]
            },
            {
                groupTitle: 'MaxTV',
                isAllowed: true,
                isGroupActive: false,
                links: [
                    {
                        title: 'Notices',
                        route: '/notices',
                        isAllowed: true
                    },
                    {
                        title: 'Classifieds',
                        route: '/classifieds',
                        isAllowed: true
                    }
                ],
                maxTv: true
            },
            {
                groupTitle: 'Settings',
                icon: 'cog.svg',
                isAllowed: this.accountService.canSetup('bldn') ||
                           this.accountService.canSetup('amenity') ||
                           this.accountService.canSetup('parking_pass') ||
                           this.accountService.isServiceAllowed('auth') ||
                           this.accountService.canSetup('parcels') ||
                           this.accountService.canSetup('service_request') ||
                           this.accountService.canSetup('key_log') ||
                           this.accountService.canSetup('inc_report') ||
                           this.accountService.canSetup('pass_on_log'),
                links: [
                    {
                        title: 'Directory',
                        route: '/directory_settings',
                        isAllowed: this.accountService.canSetup('bldn')
                    },
                    {
                        title: 'Amenities',
                        route: '/amenities_settings',
                        isAllowed: this.accountService.canSetup('amenity')
                    },
                    {
                        title: 'Parking Passes',
                        route: '/parking_passes_settings',
                        isAllowed: this.accountService.canSetup('parking_pass')
                    },
                    {
                        title: 'Website Builder',
                        route: '/website_builder',
                        isAllowed: this.accountService.isServiceAllowed('auth')
                    },
                    {
                        title: 'Parcels',
                        route: '/parcels_settings',
                        isAllowed: this.accountService.canSetup('parcels'),
                    },
                    {
                        title: 'Service Request',
                        route: '/service-request-settings',
                        isAllowed: this.accountService.canSetup('service_request')
                    },
                    {
                        title: 'Integrations',
                        route: '/integrations_settings',
                        isAllowed: this.authenticationService.user.userType == 'super_admin' // this.accountService.canSetup('service_request')
                    },
                    {
                        title: 'Key Log',
                        route: '/key_log_settings',
                        isAllowed: this.accountService.canSetup('key_log')
                    },
                    {
                        title: 'Incident Report',
                        route: '/incident_report_settings',
                        isAllowed: this.accountService.canSetup('inc_report')
                    },
                    {
                        title: 'Pass On Log',
                        route: '/pass_on_log_settings',
                        isAllowed: this.accountService.canSetup('pass_on_log')
                    },
                    {
                        title: 'Email Merge',
                        route: '/email_merge_settings',
                        isAllowed: this.accountService.canSetup('email_merge')
                    },
                    {
                        title: 'SMS Notifications',
                        route: '/settings-sms',
                        isAllowed: this.accountService.canSetup('sms')
                    },
                    // {
                    //     title: 'Stripe',
                    //     route: '/stripe-accounts',
                    //     isAllowed: false
                    // }
                ],
                settings: true
            },
        ];

        this.setAllowedItems();
    }

    setAllowedItems() {
        this.allowedListData = this.copy(this.initialListData).filter(item => {
            item.links = item.links.filter(link => link.isAllowed);

            return item.isAllowed && item.links.length;
        });
        this.setActiveGroup();
    }

    copy(data) {
        return JSON.parse(JSON.stringify(data));
    }

    /**
     * *** Deprecated ***
     * Init user logout and redirect to login page
     */
    logOut(): void {
        this.authenticationService.logout();
    }

    /**
     * Redirect user on next logout event
     */
    logoutWithRedirect() {
        this.buildingApi.getLogoutUrl().subscribe(result => {
            this.authenticationService.logout(result.logoutUrl);
        });
    }

    toggleProfileActions() {
        this.isProfileActionsShow = !this.isProfileActionsShow;
    }

    accessForMenu(el) {
        if(this.residentService.selectedBuilding.rolePermissionsMenu && this.residentService.selectedBuilding.rolePermissionsMenu.indexOf(el) > 0) {
            return true;
        } return false;
    }

    /**
     * Checks service availability
     * fof current selected building
     *
     * @param serviceKey
     */
    isServiceAvailable(serviceKey) {
        if(!this.residentService.selectedBuilding) {
            return false;
        }

        return (this.residentService.selectedBuilding.buildingServices || []).includes(serviceKey);
    }

    checkMaxTvLink() {
        return this.api.get('domainNpmiLink', '/v1/npmi.json').map(
            (res) => {
                const response = JSON.parse(res._body);
                this.isMaxTvLinkAvailable = (response.code == 200 && response.body.url);
                this.isLinkLoading = false;
                return response;
            },
            (error) => {
                this.isMaxTvLinkAvailable = false;
                this.isLinkLoading = false;
            }
        );
    }

    goToMaxTv(): void {
        this.isLinkLoading = true;
        this.checkMaxTvLink().subscribe((response) => {
            if (this.isMaxTvLinkAvailable) {
                window.open(response.body.url);
            } else {
                toastr.error('Redirect failed');
            }
        });
    }

    goToSettings(): void {
        this.showSettingsSideMenu = true;
        this.linkPriorToSettings = this.router.url;
        this.router.navigateByUrl(this.allowedListData[this.allowedListData.length - 1].links[0].route);
    }

    goBackFromSettings(): void {
        this.showSettingsSideMenu = false;
        this.router.navigateByUrl(this.linkPriorToSettings);
    }

    onSelectBuilding(building) {
        localStorage.setItem('residentselectedBuilding', JSON.stringify(building));
        this.selected = JSON.parse(localStorage.getItem('residentselectedBuilding'));

        this.residentService.selectedBuilding = building;

        if(this.residentService.selectedBuilding.rolePermissions.indexOf('parking_pass') != -1)
            this.residentService.getResidentLots(this.selected.buildingId);

        if(this.residentService.selectedBuilding.rolePermissions.indexOf('amenity') != -1) {
            this.amenitiesService.amenitiesByBuilding = [];
            this.amenitiesService.getAmenitiesListByBuilding(this.selected.buildingId);
        }

        if(this.router.url.indexOf('/front-desk-instructions') > -1) {
            this.frontDeskInstructionsService.getInstructions();
        }

        if(this.selected.theme) {
            this.cs.enableTheme(this.selected.theme);
        }

        if (this.router.url.indexOf('/service-request') > -1) {
            this.serviceRequestService.getData();
        }

        if (this.router.url.indexOf('/parcels') > -1) {
            this.parcelsService.getData();
        }

        if (this.router.url.indexOf('/documents') > -1) {
            this.urlService.setQueryParams('document', 1);
            this.documentsService.goTo(1);
        }

        if (this.router.url.indexOf('/email-merge') > -1) {
            this.emailService.getAllMailings();
        }

        if (this.router.url.indexOf('/amenities') > -1) {
            this.amenitiesService.getData();
            this.amenitiesService.getAmenitiesList();
            if(this.amenitiesService.view == 'calendar')
                this.amenitiesService.getAmenitiesForCalendarResident();
        }

        if (this.router.url.indexOf('/parking_passes') > -1)
            this.parkingPassService.getData();

        if (this.router.url.indexOf('/home') > -1) {
            this.residentService.loadWelcomeMessage();
            this.residentServicesService.updateServices();
        }

        if(this.authenticationService.userIsResident) {
            this.profileService.getResidentProfileData();
        }

        this.condomanagerService.checkEntries(); // FIXME!! dirty hack, temporary solution.
        this.checkAndSetPublicUrlNotices();
        this.residentService.getResidentServiceRequestPermissions();
    }

    navigateTo(state, saveDefaultParameters?: boolean) {
        if (this.router.url.indexOf(state + '?') == -1) {
            this.router.navigateByUrl(state).then(() => this.urlService.routeChanged.emit());
        } else if (saveDefaultParameters) {
            const params = this.urlService.getQueryParamsJson();
            this.router.navigateByUrl(state, { queryParamsHandling: 'merge' });
            const perPage = localStorage.getItem('perPage') ? parseInt(localStorage.getItem('perPage')) : 15;
            this.urlService.setQueryParams(params['tab'], 1, perPage);
        } else {
            const params = this.urlService.getQueryParamsJson();
            this.urlService.resetQueryParams();
            const perPage = localStorage.getItem('perPage') ? parseInt(localStorage.getItem('perPage')) : 15;
            this.urlService.setQueryParams(params['tab'], 1, perPage);
        }
    }

    checkAndSetPublicUrlNotices(): void {
        this.noticePmiUrl = '';
        try {
            if (this.residentService.selectedBuilding.buildingPostalCode) {
                this.api.get('domainPmiNotice', '/announcements/' + this.residentService.selectedBuilding.buildingPostalCode)
                    .subscribe(res => {
                        this.noticePmiUrl = environment.domainPmi + '/#/notices/preview/' + this.residentService.selectedBuilding.buildingPostalCode;
                    });
            }
        } catch (e) {
            console.error(e);
        }
    }

    isActiveLink(route) {
        const fullRoute = route + (route != '/home' && route != '/dashboard' ? '?' : '');
        return this.router.url.indexOf(fullRoute) != -1;
    }

    hasStripeAccount() {
        // TODO: no need to get the whole list of accounts, just get at least one
        this.stripeAccountsService.stripeAccounts$.subscribe(accounts => {
            if(this.accountService.canSetup('amenity') && accounts && accounts.length) {
                this.showStripeAdminMenu();
            }
        });
    }

    // Allows to show stripe item in Administration sections
    private showStripeAdminMenu() {
        const adminSettingsIndex = this.initialListData.findIndex(groupItem => groupItem.groupTitle == 'Administration');
        const stripeItemIndex = this.initialListData[adminSettingsIndex].links.findIndex(menuItem => menuItem.route.includes('stripe-accounts'));
        this.initialListData[adminSettingsIndex].isAllowed = true;
        this.initialListData[adminSettingsIndex].links[stripeItemIndex].isAllowed = true;

        this.setAllowedItems();
    }

    setActiveGroup() {
        if(!this.allowedListData.length)
            return;

        this.allowedListData.forEach(item => item.isGroupActive = false);

        if(this.router.url.indexOf('/email-merge?') != -1 ||
           this.router.url.indexOf('/service-request?') != -1 ||
           this.router.url.indexOf('/community?') != -1) {
            this.allowedListData.find(group => group.groupTitle == 'Communication').isGroupActive = true;
        } else if(this.router.url.indexOf('/directory?') != -1 ||
                  this.router.url.indexOf('/parcels?') != -1 ||
                  this.router.url.indexOf('/key-log?') != -1 ||
                  this.router.url.indexOf('/amenities?') != -1 ||
                  this.router.url.indexOf('/parking_passes?') != -1 ||
                  this.router.url.indexOf('/report-generator?') != -1 ||
                  this.router.url.indexOf('/maintenance-calendar?') != -1 ||
                  this.router.url.indexOf('/classifieds-mcc?') != -1 ||
                  this.router.url.indexOf('/documents?') != -1) {
            this.allowedListData.find(group => group.groupTitle == 'Record Keeping').isGroupActive = true;
        } else if(this.router.url.indexOf('/pass-on-log?') != -1 ||
                  this.router.url.indexOf('/daily-reports?') != -1 ||
                  this.router.url.indexOf('/incident-reports?') != -1) {
            this.allowedListData.find(group => group.groupTitle == 'Security').isGroupActive = true;
        } else if(this.router.url.indexOf('/management-company?') != -1 ||
                  this.router.url.indexOf('/property?') != -1 ||
                  this.router.url.indexOf('/user?') != -1 ||
                  this.router.url.indexOf('/themes?') != -1 ||
                  this.router.url.indexOf('/user-role?') != -1) {
            this.allowedListData.find(group => group.groupTitle == 'Administration').isGroupActive = true;
        } else if(this.router.url.indexOf('/user-statistics?') != -1)
            this.allowedListData.find(group => group.groupTitle == 'Statistics').isGroupActive = true;
    }

    isHomeActive() {
        return this.router.url.indexOf('/home') != -1 || this.router.url.indexOf('/dashboard') != -1;
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: HTMLElement): void {
        if (!targetElement.closest('.profile-element')) {
            this.isProfileActionsShow = false;
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/navigation/navigation.component.ts